import {
  EDIT_USER_FAILD,
  EDIT_USER_LOADING,
  EDIT_USER_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
};

export const editUserReducer = (
  state = initialState,
  action: { type: any; loading: any; status: any; error: any }
) => {
  switch (action.type) {
    case EDIT_USER_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: null,
      };
    case EDIT_USER_FAILD:
      return {
        ...state,
        loading: false,
        status: null,
        error: action.error,
      };
    default:
      return {
        loading: false,
        error: null,
        status: null,
      };
  }
};
